import React from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { App, ModalFuncProps } from 'antd'
import i18 from 'i18next'

/**
 * Hook that returns a function to show a delete confirmation modal
 * Uses App.useApp() to ensure ConfigProvider styles are applied
 */
export const useDeleteConfirmModal = () => {
  const { modal } = App.useApp()

  return (props?: ModalFuncProps) => {
    modal.confirm({
      title: i18.t('modal:deleteTitle', 'Haluatko varmasti poistaa?'),
      icon: <ExclamationCircleOutlined />,
      okText: i18.t('global:delete'),
      okType: 'danger',
      cancelText: i18.t('global:cancel'),
      ...props
    })
  }
}
